import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MyOrderDetails} from "../dtos/my-order-details";
import {MyOrdersListPage} from "../dtos/my-orders-list-page";
import {MyOrderSorting} from "../dtos/my-order-sorting.enum";
import {DropInResponse} from "@app/core/my-order/domain/dtos/drop-in-response";
import {PayOrderResponse} from "@app/core/my-order/domain/dtos/pay-order-response";
import {PaymentDetails} from '@app/core/my-order/domain/entities/PaymentDetails';


@Injectable({
    providedIn: 'root'
})
export abstract class OrderRemote {

    public abstract getOrderList(itemsPerPage: number, page: number, sorting: MyOrderSorting): Observable<MyOrdersListPage>;
    public abstract getOrderDetail(id: string): Observable<MyOrderDetails>;
    public abstract getOrderReceipt(orderNumber: string): Observable<undefined>;
    public abstract payOrder(orderCode: number, dropInResponse: DropInResponse): Observable<PayOrderResponse>;
    public abstract submitAdditionalPaymentDetails(orderCode: number, paymentDetails: PaymentDetails): Observable<PayOrderResponse>;

}
